<template>
  <router-view v-if="$can('access-service')" />
</template>

<script>
export default {
  name: 'Service'
}
</script>
